import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import TournamentsRankingView from "../../../tournaments/TournamentsRankingView.tsx";

export const Route = createFileRoute(
  '/_app/tournaments-ranking/$ranking_group_uid',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <TournamentsRankingView />
}
